export default __webpack_public_path__ + "static/media/expl-nn_14_EN.0a144294.png";